/* eslint-disable @typescript-eslint/no-unused-vars */
import { setToken } from 'api/Api';
import { isNull } from 'lodash-es';
import { useSearchParams } from 'react-router-dom';
import { ssoSignin } from 'store/auth/authSlice';
import { useAppDispatch } from 'store/hooks';

export default function useSsoAuth() {
  const [searchParams] = useSearchParams();

  const dispatch = useAppDispatch();

  const accessToken = searchParams.get('access_token');
  const refreshToken = searchParams.get('refresh_token');

  if (!isNull(accessToken) && !isNull(refreshToken)) {
    dispatch(ssoSignin({ accessToken, refreshToken }));
    setToken(accessToken);

    searchParams.delete('access_token');
    searchParams.delete('refresh_token');
  }

  return null;
}
